// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"183f0a98","977":"d0612122"}[chunkId] + ".chunk.js";
};